<template>
  <div class="d-flex">
    <span
      class="field-input me-2"
      :class="{ 'field-full': value && value !== '0' }"
      style="flex-grow: 1"
    >
      <span class="label-description">Цена</span>
      <input
        ref="cost"
        class="field-input__inner"
        autocomplete="new-password"
        :placeholder="placeholder"
        :disabled="true"
        type="text"
        :required="true"
        :max-length="8"
        inputmode="decimal"
        :value="value === '0' ? '' : value"
      >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M14.25 3H7.5V11.25H5.25V12.75H7.5V15H5.25V16.5H7.5V21H9V16.5H15.75V15H9V12.75H14.25C15.443 12.7486 16.5868 12.2741 17.4304 11.4304C18.2741 10.5868 18.7486 9.44305 18.75 8.25V7.5C18.7486 6.30695 18.2741 5.16317 17.4304 4.31955C16.5868 3.47594 15.443 3.00139 14.25 3ZM17.25 8.25C17.249 9.04534 16.9326 9.80783 16.3702 10.3702C15.8078 10.9326 15.0453 11.249 14.25 11.25H9V4.5H14.25C15.0453 4.50099 15.8078 4.81738 16.3702 5.37978C16.9326 5.94217 17.249 6.70466 17.25 7.5V8.25Z"
          fill="#50616F"
        />
      </svg>
    </span>
    <span
      class="field-input"
      :class="{ 'field-full': value && value !== '0' }"
      style="flex-grow: 1"
    >
      <span class="label-description">Цена</span>
      <input
        ref="cost"
        class="field-input__inner"
        autocomplete="new-password"
        :placeholder="placeholder"
        :disabled="true"
        type="text"
        :required="true"
        :max-length="8"
        :value="exportCost === '0.00' ? '' : exportCost"
        inputmode="decimal"
      >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12.75 19.5C10.038 19.5 8.00025 17.7773 7.1655 15H14.25V13.5H6.849C6.7832 13.0027 6.75013 12.5016 6.75 12C6.75 11.7525 6.7575 11.502 6.7695 11.25H14.25V9.75H6.92775C7.38375 7.014 8.8575 4.5 12.75 4.5C15.6397 4.5 16.899 5.73525 18.096 7.8675L19.404 7.1325C18.1987 4.98675 16.5585 3 12.75 3C7.98375 3 5.25 6.2805 5.25 12C5.25 17.2987 8.334 21 12.75 21C16.5585 21 18.1987 19.014 19.404 16.8675L18.096 16.1325C16.899 18.2655 15.6397 19.5 12.75 19.5Z"
          fill="black"
        />
      </svg>

    </span>
  </div>
  <!--    <div-->
  <!--      v-if="showExportCost || exportCostForce"-->
  <!--      class="input-cost-custom__cost-currency"-->
  <!--    >-->
  <!--      {{ exportCost }} €-->
  <!--    </div>-->
</template>
<script>
/* global IMask */
import _ from 'lodash';
import { exportCost } from '../../../models/calculator-customs';
import { PACKAGE_TYPE } from '../../../helpers/constans';

export default {
  name: 'CostCustoms',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 6,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showExportCost: {
      default: false,
      type: Boolean,
    },
    exportCostForce: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    exportCost: '0.00',
    vMask: null,
  }),
  watch: {
    value(val) {
      if (this.exportCostForce || this.showExportCost) {
        this.vMask.value = val;
      }
      if (!this.showExportCost) return;
      if (val === '0') {
        this.exportCost = '0.00';
        this.$emit('export-cost', '0.00');
        return;
      }
      this.debouncedFetchExportCost(val);
    },
    exportCost(val) {
      this.$emit('export-cost', val.toString());
    },
    exportCostForce: {
      handler(val) {
        if (val) {
          let cost = val;
          if (typeof cost === 'string') {
            cost = (+(cost.replace(/\s/g, ''))).toFixed(2);
          }
          this.exportCost = (val !== '0') ? cost : '0.00';
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init();
  },
  created() {
    this.PACKAGE_TYPE = PACKAGE_TYPE;
    if (this.showExportCost) {
      this.debouncedFetchExportCost = _.debounce(this.fetchExportCost, 1000);
    }
  },
  methods: {
    fetchExportCost(cost) {
      let price = cost;
      if (typeof cost === 'string') {
        price = cost.replace(/\s/g, '');
      }
      exportCost(price, '051')
        .then((total) => {
          if (this.value === '0') return;
          this.exportCost = total.toFixed(2);
        })
        .catch((errArr) => {
          this.$emit('error', errArr.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    init() {
      const costImask = {
        mask: Number,
        min: 0,
        thousandsSeparator: ' ',
        radix: '.',
        mapToRadix: [','],
      };

      this.vMask = IMask(this.$refs.cost, costImask);
    },
    onChangeCost(e) {
      const value = e.target.value.replace(',', '.').replaceAll(' ', '');
      if (value.includes('.')) {
        const fractional = value.split('.');
        if (fractional[1] && fractional[1].length > 2) return;
      }
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.price-input {
  text-align: left !important;
}
.input-cost-custom {
  display: flex;
  align-items: center;
  width: 100%;
  @media (max-width: 767px) {
    flex-direction: column;
  }
  & .field-input__inner {
    padding: 12px 24px;
    min-height: 60px;
    height: 60px;
    &:disabled {
      background-color: transparent;
    }
  }
}
.input-cost-custom__cost-currency {
  min-width: 74px;
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #9FB3C3;
  text-align: right;
  @media (max-width: 767px) {
    margin-top: 4px;
    align-self: flex-end;
    margin-right: 24px;
  }
}
.input-cost-custom__input-wrap {
  position: relative;
  width: 100%;
  input {
    padding-right: 41px !important;
  }
  .input-cost-custom__icon {
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #9FB3C3;
  }
}
</style>
